import { api } from "../../api";

/**
 * Google Drive connection endpoints.
 * Auth cookies and the parent-company header come from the shared base query.
 */
const googleDriveApi = api.injectEndpoints({
  endpoints: (builder) => ({
    getGoogleDriveStatus: builder.query({
      query: () => "google-drive",
      providesTags: ["GoogleDrive"],
    }),
    getGoogleDriveFolders: builder.query({
      query: () => "google-drive/folders",
    }),
    connectGoogleDrive: builder.query({
      query: () => "google-drive/connect",
    }),
    updateGoogleDrive: builder.mutation({
      query(body) {
        return {
          url: "google-drive",
          method: "PUT",
          body,
        };
      },
      invalidatesTags: ["GoogleDrive"],
    }),
    disconnectGoogleDrive: builder.mutation({
      query() {
        return {
          url: "google-drive",
          method: "DELETE",
        };
      },
      invalidatesTags: ["GoogleDrive"],
    }),
  }),
  overrideExisting: false,
});

export const {
  useGetGoogleDriveStatusQuery,
  useLazyGetGoogleDriveFoldersQuery,
  useLazyConnectGoogleDriveQuery,
  useUpdateGoogleDriveMutation,
  useDisconnectGoogleDriveMutation,
} = googleDriveApi;
